import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Icebox/Main";
import Form from "./Icebox/Form";

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxIbNo,
  getCustByType,
} from "../../../utils/SamuiUtils";
import Navbar from "../../components/Modal/Navbar";

const Icebox = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [dataMasterHistoryList, setDataMasterHistoryList] = useState([]);
  const [dataDetailHistoryList, setDataDetailHistoryList] = useState([]);
  const [maxIbNo, setMaxIbNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // สำหรับหน้ารายการ
      const masterList = await getCustByType("5", "F");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      const detailList = await getDataWithComp(
        "API_1002_WHDOC_D",
        `AND WHDocType_Name = 'Deposit' AND Item_Is_Return = 0 ORDER BY Line ASC`
      );
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // สำหรับหน้าประวัติการยืม
      const masterHistoryList = await getCustByType("5", "H");
      if (masterHistoryList && masterHistoryList.length > 0) {
        setDataMasterHistoryList(masterHistoryList);
      }
      const detailHistoryList = await getDataWithComp(
        "API_1002_WHDOC_D",
        `AND WHDocType_Name = 'Deposit' ORDER BY Line ASC`
      );
      if (detailHistoryList && detailHistoryList.length > 0) {
        setDataDetailHistoryList(detailHistoryList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ IB (ใบยืมสินค้า)
      const findMaxIbNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '5' ORDER BY WHDoc_No DESC`
      );
      const maxIb = getMaxIbNo(findMaxIbNo);
      setMaxIbNo(maxIb);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onPageUpdate = (whDocNo) => {
    setMaxIbNo(whDocNo);
    setMode("U");
  };

  return (
    <div>
      <div className="Icebox">
        <div className="wrapper">
          <Navbar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === "S" ? (
                  <Main
                    name={"ใบยืมสินค้า"}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                    dataMasterHistoryList={dataMasterHistoryList}
                    dataDetailHistoryList={dataDetailHistoryList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(whDocNo) => onPageUpdate(whDocNo)}
                    callInitialize={() => initialize()}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    name={"ใบยืมสินค้า"}
                    whDocNo={maxIbNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Icebox;
